import { defineMessages } from 'react-intl';

export const messagesCliplister = defineMessages({
  cliplisterModalTitle: {
    id: 'cliplister.modal.title',
    defaultMessage: 'Produkt Video',
  },
  buttonLabel: {
    id: 'cliplister.aria.button',
    defaultMessage: 'Produktvideo abspielen',
  },
});
